import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { ThemeService } from "src/app/services/theme.service";
import { Theme } from "src/app/models/theme";

@Component({
  selector: "app-prices-page",
  templateUrl: "./prices-page.component.html",
  styleUrls: ["./prices-page.component.scss"],
})
export class PricesPageComponent implements OnInit {
  static readonly SEARCH_QUERY_PARAM = "search";
  search: string = "";

  private destroyRef = inject(DestroyRef);

  constructor(
    private route: ActivatedRoute,
    private themeService: ThemeService,
  ) {}

  ngOnInit() {
    this.themeService.set(Theme.Light, false);

    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.search = params.get(PricesPageComponent.SEARCH_QUERY_PARAM) || "";
      });
  }
}
